import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AgendaTableauCell } from "@treeosk/common";
import queries from "../../../queries";
import SpecificCellPreview from "./SpecificCellPreview";

class AgendaTableauCellPreview extends React.Component {

    render() {
        const { cell } = this.props;
        const defaultRender = () => <FontAwesomeIcon icon={'columns'} />;

        return (
            <SpecificCellPreview
                cell={cell}
                defaultRender={defaultRender}
                query={queries.cells.agenda_tableau.get}
                renderingCondition={() => true}
            >
                {(agendaTableauCell) => <AgendaTableauCell preview={true} cell={agendaTableauCell} />}
            </SpecificCellPreview>
        );
    }

}

export default AgendaTableauCellPreview;
